import React from 'react';
import { useLocation } from 'react-router-dom';
import { FormControllerProvider } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { dateTime } from '../../../../shared/packages/dateTime';

const { fromDate: fromName, toDate: toName } = fieldNames.main;

const FormProvider = ({ children }) => {
  const { state } = useLocation();

  const values = state.from.values;

  const options = {
    defaultValues: {
      ...values,
      [fromName]: dateTime(values[fromName]),
      [toName]: dateTime(values[toName]),
    },
  };

  return (
    <FormControllerProvider options={options}>
      {children}
    </FormControllerProvider>
  );
};

export default FormProvider;
